import { useEffect, useState } from "react";

export const useTheme = () => {
  const [dark, setDark] = useState(() => {
    const saved = localStorage.getItem("bp_theme");
    if (saved) return saved === "dark";
    return false;
  });

  useEffect(() => {
    const root = document.documentElement;
    if (dark) root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem("bp_theme", dark ? "dark" : "light");
  }, [dark]);

  return { dark, toggle: () => setDark((d) => !d) };
};
